import * as Flags from "country-flag-icons/react/1x1";
import clsx from "clsx";

export function Flag({ code, className }: { code: string; className?: string }) {
  const ActiveCountryFlag = Flags[code as keyof typeof Flags];

  return <ActiveCountryFlag className={clsx("[clip-path:circle(40%)] [transform:translateZ(0)]", className)} />;
}
